(() => {
  'use strict';
  if (window.itcKlarnaReady) return;
  window.itcKlarnaReady = true;
  const awareness = document.querySelector('[data-itc-klarna="awareness"]');
  const amount = document.querySelector('[data-itc-klarna="amount"]');
  if (!awareness || !amount) return;
  const home = amount.parentElement;
  const placement = amount.querySelector('klarna-placement');
  const visible = element => element && !element.closest('[hidden]') && element.getClientRects().length > 0;
  const cents = element => {
    const match = element?.textContent.match(/£\s*([\d,]+(?:\.\d{1,2})?)/);
    return match ? Math.round(Number(match[1].replaceAll(',', '')) * 100) : 0;
  };
  const refresh = () => {
    (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []).push({eventName:'refresh-placements'});
  };
  const showNative = container => {
    const native = container.querySelector('klarna-placement');
    const fallback = container.querySelector('[data-itc-klarna-fallback]');
    if (fallback) fallback.hidden = Boolean(native && native.getBoundingClientRect().height > 0);
  };
  let lastAmount = -1;
  let frame = 0;
  function update() {
    frame = 0;
    const portrait = [...document.querySelectorAll('[data-portrait-personaliser]')].find(visible);
    const star = [...document.querySelectorAll('[data-star-map-modal]')].find(visible);
    const football = [...document.querySelectorAll('[data-football-range]')].find(visible);
    const card = [...document.querySelectorAll('[data-magic-panel]')].find(visible);
    let price;
    let target;
    if (portrait) {
      price = [...portrait.querySelectorAll('[data-itc-price]')].find(visible);
      target = price?.closest('.itc-live-total');
    } else if (star) {
      price = star.querySelector('[data-star-map-form] [data-itc-price]');
      target = price;
    } else if (football) {
      price = football.querySelector('[data-football-price]');
      target = football.querySelector('[data-football-add]');
    } else if (card) {
      price = card.querySelector('[data-magic-total]');
      target = card.querySelector('.magic-cards__buybar');
    } else {
      price = document.querySelector('.itc-cart__total strong, .itc-starting-offer strong');
      target = price?.closest('.itc-cart__total, .itc-starting-offer');
    }
    const value = cents(price);
    if (target && value > 0) {
      if (portrait) {
        if (amount.parentElement !== target) target.append(amount);
      } else if (target.nextElementSibling !== amount) target.after(amount);
      amount.hidden = false;
      if (placement && (lastAmount !== value || placement.getAttribute('data-purchase-amount') !== String(value))) {
        lastAmount = value;
        placement.setAttribute('data-purchase-amount', String(value));
        refresh();
      }
    } else {
      amount.hidden = true;
      if (amount.parentElement !== home) home.append(amount);
    }
    const first = document.querySelector('#MainContent > .shopify-section');
    if (first && !document.querySelector('.portrait-product__summary, .itc-cart')) {
      if (first.nextElementSibling !== awareness) first.after(awareness);
      awareness.classList.add('itc-klarna--strip');
      awareness.hidden = false;
    } else {
      awareness.hidden = true;
    }
    showNative(awareness);
    showNative(amount);
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const priceObserver = new MutationObserver(schedule);
  if (placement) priceObserver.observe(placement,{attributes:true,attributeFilter:['data-purchase-amount']});
  document.querySelectorAll('[data-itc-price], [data-football-price], [data-magic-total], .itc-cart__total strong').forEach(element => priceObserver.observe(element,{childList:true,subtree:true,characterData:true}));
  const stateObserver = new MutationObserver(schedule);
  document.querySelectorAll('[data-portrait-personaliser], [data-star-map-modal], [data-football-range], [data-magic-panel]').forEach(element => stateObserver.observe(element,{attributes:true,attributeFilter:['hidden','open','class']}));
  document.addEventListener('change',schedule);
  document.addEventListener('input',schedule);
  window.addEventListener('pageshow',schedule);
  if (window.ResizeObserver) {
    const nativeObserver = new ResizeObserver(() => {showNative(awareness);showNative(amount);});
    document.querySelectorAll('[data-itc-klarna] klarna-placement').forEach(element => nativeObserver.observe(element));
  }
  update();
  [250,1000,3000].forEach(delay => setTimeout(() => {lastAmount = -1; update();},delay));
})();
